import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { EasyClaimCaseResponseDto } from 'src/easyclaim.api.client.typescript/src';
import { reportError } from 'src/easyclaim.app.libs/reportError';
import { EasyClaimDocumentService } from 'src/easyclaim.app.services';

import {
	ChangeLangButton,
	HamburgerContainer,
	MenuButtonContainer,
	MenuContainer,
	StyledIconMenu,
} from '../easyclaim.app.components';

import ButtonConfiguration from './ButtonConfiguration';
import { LogoImage } from './LogoImage';

export interface AppHeaderProps {
	isLogoVisible: boolean;
	caseId?: string;
	documentService?: EasyClaimDocumentService;
	BackButtonConfiguration: ButtonConfiguration;
	MenuButtonConfiguration: ButtonConfiguration;
	ShowChangeLangModalButtonConfiguration: ButtonConfiguration;
	EasyClaimCase?: EasyClaimCaseResponseDto;
}

export function AppHeaderNavigation(props: AppHeaderProps) {
	const executeAction = (action: () => Promise<void>) => {
		void action().catch((error: unknown) => {
			reportError(error, { context: 'AppHeaderNavigation' });
		});
	};

	return (
		<MenuContainer className="menu-container">
			<MenuButtonContainer className="flex-row left">
				{props.BackButtonConfiguration.isVisible && (
					<button
						className="button-small header-nav-back-button"
						onClick={() => executeAction(props.BackButtonConfiguration.onClick)}
					>
						<span className="back-button-arrows">« </span>
						<FormattedMessage id={props.BackButtonConfiguration.textId} />
					</button>
				)}
			</MenuButtonContainer>
			{props.isLogoVisible && props.caseId && props.documentService && (
				<div className="logo-container">
					<LogoImage caseId={props.caseId} documentService={props.documentService} />
				</div>
			)}
			<MenuButtonContainer className="flex-row right">
				{props.ShowChangeLangModalButtonConfiguration.isVisible && (
					<ChangeLangButtonMemo
						currentLang={props.ShowChangeLangModalButtonConfiguration.textId}
						onOpenChangeLangModal={() =>
							executeAction(props.ShowChangeLangModalButtonConfiguration.onClick)
						}
						EasyClaimCase={props.EasyClaimCase!}
					/>
				)}
				{props.MenuButtonConfiguration.isVisible && (
					<HamburgerContainer onClick={() => executeAction(props.MenuButtonConfiguration.onClick)}>
						<StyledIconMenu />
					</HamburgerContainer>
				)}
			</MenuButtonContainer>
		</MenuContainer>
	);
}

const ChangeLangButtonMemo = memo(ChangeLangButton);
